@if (hasFeatureAndRoleAccess()) {
  @if (sensitiveDataAccess() === true) {
    @if (collectionCaseCompositeData(); as collectionCaseCompositeData) {
      <nk-card id="company-payment-remarks-card">
        <nk-card-header
          title="{{ 'company_page.payment_remarks_card.header' | translate }}"
          [favicon]="'fa-exclamation-triangle'"></nk-card-header>
        @if (collectionCaseCompositeData.collectionCaseCompositeEntities.length) {
          <nk-card-content type="table">
            <div class="row">
              <div [class]="printVersion() ? 'col-4' : 'col-12 col-sm-4'">
                <p>{{ 'company_page.payment_remarks_card.stats.sum' | translate }}</p>
                <h4 class="text-danger">
                  <b>{{ collectionCaseCompositeData.sum | accountsNumber: 1 }} NOK</b>
                </h4>
              </div>
              <div [class]="printVersion() ? 'col-4' : 'col-12 col-sm-4'">
                <p>{{ 'company_page.payment_remarks_card.stats.quantity' | translate }}</p>
                <h4>
                  <b>{{ collectionCaseCompositeData.quantity }}</b>
                </h4>
              </div>
              <div [class]="printVersion() ? 'col-4' : 'col-12 col-sm-4'">
                <p>{{ 'company_page.payment_remarks_card.stats.quantity_without_creditors' | translate }}</p>
                <h4>
                  <b>{{ collectionCaseCompositeData.quantityWithoutCreditors }}</b>
                </h4>
              </div>
            </div>
            @if (collectionCaseCompositeData.collectionCaseCompositeEntities.length > 1) {
              <div class="row mt-4">
                <div class="col">
                  <nk-company-payment-remarks-chart
                    [collectionCaseCompositeEntities]="collectionCaseCompositeData.collectionCaseCompositeEntities"
                    [printVersion]="printVersion()"></nk-company-payment-remarks-chart>
                </div>
              </div>
            }
            <div class="row">
              <div class="col">
                <nk-company-payment-remarks-table
                  [collectionCaseCompositeEntities]="collectionCaseCompositeData.collectionCaseCompositeEntities"
                  [printVersion]="printVersion()"></nk-company-payment-remarks-table>
              </div>
            </div>
          </nk-card-content>
        } @else {
          <nk-card-content type="table">
            <div class="row">
              <div class="col">
                <div class="alert alert-info">
                  {{ 'company_page.payment_remarks_card.no_payment_remarks_found' | translate }}
                </div>
              </div>
            </div>
          </nk-card-content>
        }
      </nk-card>
    }
  } @else if (sensitiveDataAccess() === null) {
    <nk-card>
      <nk-card-header
        title="{{ 'company_page.payment_remarks_card.header' | translate }}"
        [favicon]="'fa-exclamation-triangle'"></nk-card-header>
      <nk-card-content>
        <nk-payment-remarks-section
          [companyUuid]="companyUuid()"
          [enableMessage]="'company.event_feed.options.payment_remarks.payment_remarks_enable_message' | translate">
        </nk-payment-remarks-section>
      </nk-card-content>
    </nk-card>
  }
}
